<script setup>
  import { computed } from 'vue';
  import Icon from './icons/Icon.vue';
  import ProForecastListForecasterPhoto from './ProForecastListForecasterPhoto.vue';

  const props = defineProps({
    forecast: {
      type: Object,
      required: true
    },
    showForecasterPhoto: {
      type: Boolean,
      default: false
    },
    forecasterImageFile: {
      type: String,
      default: null
    }
  });

  const forecastName = computed(() => props.forecast.type === 'extended' ? `${props.forecast.forecast_name} Extended` : props.forecast.forecast_name)
  const forecastUrl = computed(() => `${window.location.origin}/proforecast/${props.forecast.forecast_id}`)
  const season = computed(() => props.forecast.season_status === 'active' ? 'Active' : 'Out of Season')
</script>

<template>
  <li class="jwx-pro-forecast-list__item">
    <a 
      :href="forecastUrl" 
      class="jwx-pro-forecast-list__link-block"
      :data-show-photo="props.showForecasterPhoto"
    >
      <ProForecastListForecasterPhoto v-if="props.showForecasterPhoto" :forecaster-image-file="props.forecasterImageFile" :season-status="props.forecast.season_status" />
      <div class="jwx-pro-forecast-list__forecast-info">
        <h3 class="jwx-pro-forecast-list__forecast-name">{{ forecastName }}</h3>
        <slot name="subtitle" />
      </div>
      <div class="jwx-pro-forecast-list__season-status" :data-status="props.forecast.season_status">
        <p class="jwx-pro-forecast-list__status">{{ season }}</p>
        <span class="jwx-pro-forecast-list__status-indicator"></span>
      </div>
      <div class="jwx-pro-forecast-list__nav-indicator">
        <Icon name="chevron-right" />
      </div>
    </a>
  </li>
</template>
